import React from 'react';
import { Spinner } from '@blueprintjs/core';

const LoadingIndicator: React.FC<{ size?: number }> = props => <Spinner {...props} />;

export default LoadingIndicator;
